import React from 'react';
import { Data } from '../../types/data-providers';
import { useData, dataFromDataset } from './DataProviderCache';
import * as DeviceManager from '../domain/device-manager';
import { useAuthHelper } from '../../components/AuthContextProvider';
import { MeshDeviceDetails } from '../../types/device';

type ContextState = Data<MeshDeviceDetails>;
const Context = React.createContext<ContextState | null>(null);

function useMeshDeviceDetails(): ContextState {
    const contextState = React.useContext(Context);
    if (contextState === null) {
        throw new Error('useDeviceDetails must be used within a MeshDeviceDetailsProvider');
    }
    return contextState;
}

const MeshDeviceDetailsProvider: React.FC<{ deviceId: string }> = (props) => {
    const authHelper = useAuthHelper();
    const { dataset } = useData({
        cacheKey: 'mesh-device-details',
        id: props.deviceId,
        dataFn: React.useCallback(() => DeviceManager.getMeshGatewayDeviceDetails(authHelper, props.deviceId), [
            authHelper,
            props.deviceId,
        ]),
    });

    const deviceDetailsData = dataFromDataset(dataset);

    return <Context.Provider value={deviceDetailsData}>{props.children}</Context.Provider>;
};

const TestMeshDeviceDataProvider: React.FC<{ value: ContextState }> = (props) => (
    <Context.Provider value={props.value}>{props.children}</Context.Provider>
);

export { MeshDeviceDetailsProvider, TestMeshDeviceDataProvider, useMeshDeviceDetails };
